"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/scroll_to.ts
// module id = 10
// module chunks = 0